"use client";
import { useEffect, useRef, useState } from "react";
import Minus from "@/public/icon/minus.svg";
const Seo = ({ item, t }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);

  return (
    <div className="container">
      <div className="seo">
        <h2>{item?.title}</h2>
        <div className={`seoContent ${open ? "active" : ""}`}>
          {/* <p>{item?.meta_description}</p> */}
          <div
            dangerouslySetInnerHTML={{
              __html: item.content,
            }}
          />
        </div>
        <button
          type="button"
          className={open ? "active" : ""}
          onClick={toggleOpen}
        >
          <span>{t["button.read_more"]}</span>
          <Minus />
        </button>
      </div>
    </div>
  );
};

export default Seo;
